import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_DMX_OCCUPANCY } from './actionTypes';
import { getDmxOccupancySuccess, getDmxOccupancyError } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* getOccupancy({ payload: { user, universeId } }) {
  try {
    const response = yield call(dmxAPI.getOccupancy, user.token, universeId);
    yield put(getDmxOccupancySuccess(response));
  } catch (error) {
    yield put(getDmxOccupancyError(error));
  }
}

export function* watchGetDmxOccupancy() {
  yield takeEvery(GET_DMX_OCCUPANCY, getOccupancy);
}

function* getDmxOccupancySaga() {
  yield all([fork(watchGetDmxOccupancy)]);
}

export default getDmxOccupancySaga;
